import axios from "axios";
import { clearSession, getToken, isPublicPath } from "../auth/session";

const baseURL = process.env.REACT_APP_API_BASE_URL;

const axiosInstance = axios.create({
    baseURL,
    // Required: /images/download-presigned-url authorises CloudFront by setting
    // signed cookies on its response. A cross-origin response's Set-Cookie is only
    // honoured in credentials mode, so without this every image 403s.
    withCredentials: true,
    headers: {
        "Content-Type": "application/json",
    },
});

axiosInstance.interceptors.request.use(
    (config) => {
        const token = getToken();
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error),
);

// The server rejecting our token outranks anything the client believes about
// the session. Without this the app kept rendering a signed-in shell full of
// failing requests.
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            clearSession();
            if (!isPublicPath(window.location.pathname)) {
                // Hard navigation rather than the router, so in-memory redux and
                // react-query state goes with the session.
                window.location.replace("/");
            }
        }
        return Promise.reject(error);
    },
);

export default axiosInstance;
